// @flow

import congfigSchema from "./schema/config";
import productSchema from "./schema/product";
import settingsSchema from "./schema/settings";

class SchemaFactory {
    /**
     * @type {?SchemaFactory}
     */
    static schemaFactoryInstance = null;

    /**
     *
     * @returns {SchemaFactory}
     */
    static getInstance() {
        if (SchemaFactory.schemaFactoryInstance == null) SchemaFactory.schemaFactoryInstance = new SchemaFactory();
        return SchemaFactory.schemaFactoryInstance;
    }


    constructor() {
        this.schemas = {
            config: congfigSchema,
            product: productSchema,
            settings: settingsSchema
        };
    }

    addSchema(schemaName, schema) {
        this.schemas[schemaName] = schema;
    }

    getSchema(schemaName): {...} {
        return this.schemas[schemaName];
    }
}

export default SchemaFactory;
